import { Collapse, Form, List, Tag, Tooltip } from "antd"
import { pricingTypeName, PricingTypes } from "../../../common/constants"
import { centsToDollarsDisplay } from "../../displayFormatters"
import RichTextEditor from "../../RichTextEditor/RichTextEditor"
import { isEmptyRichText } from "../../RichTextEditor/richTextModel"
import { groupProposalWorkareas, ProposalWorkareaGroup, Workarea } from "./proposalsModel"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCirclePause, faLock } from "@fortawesome/pro-solid-svg-icons"
import { useWorkareaGroupsQuery } from "../../../domain/workareas/groupsQueries"

type Props = {
  jobId: number
  workareas: Workarea[]
  redesign?: boolean
}

const ProposalWorkareas = ({ workareas, jobId, redesign = false }: Props) => {
  const workareaGroupQuery = useWorkareaGroupsQuery(jobId)
  const proposalGroups = groupProposalWorkareas(workareaGroupQuery.data ?? [], workareas)

  const getPricePrefix = (proposalGroup: ProposalWorkareaGroup) => {
    if (proposalGroup.pricingType === PricingTypes.TimeAndMaterials || proposalGroup.pricingType === PricingTypes.FlatRate) {
      return 'Estimated '
    }
    return ''
  }

  const getPricePostfix = (proposalGroup: ProposalWorkareaGroup) => {
    if (proposalGroup.pricingType === PricingTypes.PerVisit) {
      return ' per Visit'
    }
    return ''
  }

  return <Collapse defaultActiveKey={1} style={{ marginBottom: '20px' }} items={[
    {
      key: 1,
      label: `Workareas (${proposalGroups.length ?? 0})`,
      children: <List
        dataSource={proposalGroups.length > 0 ? proposalGroups : []}
        renderItem={(proposalGroup) => (
          <List.Item>
            <div style={{ width: '100%' }} >
              <Form layout="inline">
                <Form.Item style={{ width: '100%', marginBottom: '10px' }}>
                  {proposalGroup.locked && <Tag color="blue"><Tooltip title={`${proposalGroup.workareaCount > 1 ? 'These workareas were' : 'This work area was'} locked for this proposal.`}><FontAwesomeIcon icon={faLock} /></Tooltip></Tag>}
                  <span style={{ fontSize: '20px' }}>{proposalGroup.name} {proposalGroup.isOnHold && <Tag color="blue"><FontAwesomeIcon icon={faCirclePause} /> On Hold</Tag>}</span>
                  <span style={{ float: 'right', fontSize: '20px' }}>{getPricePrefix(proposalGroup)}Price: {centsToDollarsDisplay(proposalGroup.quotedPrice) ?? 0}{getPricePostfix(proposalGroup)}</span>
                </Form.Item>
                <Form.Item style={{ width: '100%', marginBottom: '10px' }}>
                  <div style={{ fontSize: '16px' }}>{proposalGroup.workareaCount > 1 ? 'These workareas are' : 'This work area is'} using {pricingTypeName(proposalGroup.pricingType)} pricing.</div>
                </Form.Item>
              </Form>
              {(!redesign || !isEmptyRichText(proposalGroup.description)) && <div style={{ width: '100%' }}>
                <RichTextEditor value={proposalGroup.description} disabled={true} removeToolbar={true} />
              </div>}
            </div>
          </List.Item>
        )}
      />
    }
  ]} />
}

export default ProposalWorkareas
